<ion-content>
  <ion-header>
    <ion-toolbar>
      <ion-back-button color="white" slot="start" defaultHref="/home" text="" icon="chevron-back"></ion-back-button>

      <ion-title>
        <ion-text color="white" class="ion-text-center">
          <h2>{{ "Search" | translate }}</h2>
        </ion-text>
        
      </ion-title>
    </ion-toolbar>
  </ion-header>


  <ion-row>
    <ion-col size="12">
      <ion-searchbar [(ngModel)]="searchQuery"></ion-searchbar>
    </ion-col>

  </ion-row>

  <ion-row *ngIf="(menuItems | search:searchQuery)">

    <ng-container *ngIf="!searchQuery">
      <ion-col sizeLg="6" offsetLg="3" size="12"
        class="error">
        <ion-icon color="medium" name="search-outline" style="font-size: 128px;"></ion-icon><br>
        <ion-text color="medium">
          <h2>{{"You haven't searched yet." | translate }}</h2>
        </ion-text>
      </ion-col>

    </ng-container>
    <ng-container *ngIf="(menuItems | search:searchQuery).length == 0 && searchQuery != ''">
      <ion-col sizeLg="6" offsetLg="3" size="12"
        class="error">
        <ion-icon color="medium" name="sad-outline" style="font-size: 128px;"></ion-icon><br>
        <ion-text color="medium" >
          <h2>{{"We couldn't find any results matching your search." | translate }}</h2>
        </ion-text>
      </ion-col>

    </ng-container>
  </ion-row>
  <ion-row *ngIf="searchQuery">
    <ion-col sizeLg="4" size="12" *ngFor="let item of (menuItems | search:searchQuery)">
      <ion-card routerLink="{{item.menu_section_id}}/{{item.id}}">
        <ion-img [src]="item.image_url" *ngIf="item.image_url"></ion-img>

        <div class="bottom">
          <ion-text color="white">
            <h2><b [innerHtml]="item.name | caption | translate"></b></h2>
          </ion-text>
        </div>
      </ion-card>
    </ion-col>
  </ion-row>
</ion-content>